import React from 'react';
import 'bootstrap/dist/css/bootstrap.min.css';

const Loading = ({ loadingText }) => {
    return (
        <div className={`loader-overlay show`}>
            <div className="load-inner">
                <div className="spinner-border" role="status"></div>
                <span className="loader-text">{loadingText}</span>
            </div>
        </div>
    );
};

export default Loading;
